<template>
<div class="menu_Full">
  <div v-if="dataReady">
    <div class="menu_Section" v-for="section in btqMenu" v-bind:key="section.id">
      <h2 v-bind:id="section.title | sanitize">{{ section.title }}</h2>      
      <div v-html="section.html" />
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'MenuFull',
  props: {
    btqMenu: Array
  },
  data(){
    return{
      dataReady: false,
    }
  },
  beforeMount() {
    if (this.btqMenu != null){
      this.dataReady = true
    }
  },
  computed: {
    apiUrl() {
      return 'http://localhost:8000'
    },
  }
}
</script>
